/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ManufacturerModelsDto
 */
export interface ManufacturerModelsDto {
    /**
     * 
     * @type {string}
     * @memberof ManufacturerModelsDto
     */
    manufacturer?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ManufacturerModelsDto
     */
    models?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ManufacturerModelsDto
     */
    $type?: ManufacturerModelsDtoTypeEnum;
}


/**
 * @export
 */
export const ManufacturerModelsDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoManufacturerModelsDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.ManufacturerModelsDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ManufacturerModelsDtoTypeEnum = typeof ManufacturerModelsDtoTypeEnum[keyof typeof ManufacturerModelsDtoTypeEnum];


/**
 * Check if a given object implements the ManufacturerModelsDto interface.
 */
export function instanceOfManufacturerModelsDto(value?: unknown): value is ManufacturerModelsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ManufacturerModelsDtoTypeEnum)[0];
}

export function ManufacturerModelsDtoFromJSON(json: any): ManufacturerModelsDto {
    return ManufacturerModelsDtoFromJSONTyped(json, false);
}

export function ManufacturerModelsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManufacturerModelsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'manufacturer': !exists(json, 'manufacturer') ? undefined : json['manufacturer'],
        'models': !exists(json, 'models') ? undefined : json['models'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ManufacturerModelsDtoToJSON(value?: ManufacturerModelsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'manufacturer': value.manufacturer,
        'models': value.models,
        '$type': value.$type,
    });
}

